// ============ VERSION ============

// Versión del widget TIA GPC
export const WIDGET_VERSION = '3.1.0';

// ============ CAPTCHA MATEMÁTICO ============

// Duración de validez del CAPTCHA (en DÍAS)
export const CAPTCHA_VALIDITY_DAYS = 30;

// Conversión a milisegundos para uso interno
export const CAPTCHA_VALIDITY_MS = CAPTCHA_VALIDITY_DAYS * 24 * 60 * 60 * 1000;

// Keys de localStorage para el CAPTCHA
export const CAPTCHA_STORAGE_KEYS = {
  VERIFIED: 'gpc_captcha_verified',
  TIMESTAMP: 'gpc_captcha_timestamp'
};

// ============ VALIDACIÓN DE FIRMAS HMAC ============

// Tiempo máximo de vida de una firma (en SEGUNDOS)
export const HMAC_SIGNATURE_MAX_AGE_SECONDS = 60;

// ============ METADATA DEL CLIENTE (Bot Detection) ============

// Nombres de campos honeypot (DEBEN coincidir con el backend)
export const HONEYPOT_FIELD_NAMES = [
  'honeypot_field_1',
  'honeypot_field_2',
  'hp_field'
];

// Campos de metadata del navegador requeridos
// Información que se envía al backend para validar que es un navegador real
export const BROWSER_METADATA_FIELDS = [
  'screen_resolution',
  'timezone',
  'platform',
  'language',
  'color_depth'
];

// ============ SESIONES ============

// Duración del caché de conversación en localStorage (en HORAS)
export const CONVERSATION_CACHE_HOURS = 24;

// Conversión a milisegundos
export const CONVERSATION_CACHE_MS = CONVERSATION_CACHE_HOURS * 60 * 60 * 1000;

// Key de sessionStorage para datos de login MCP
export const MCP_LOGIN_STORAGE_KEY = 'mcp_login_data';

// ============ CONFIGURACIÓN DE DESARROLLO ============

// Logs de debug en desarrollo
export const DEBUG_SECURITY = process.env.NODE_ENV === 'development';

// Helper para logs condicionales
export const securityLog = (...args) => {
  // Logs deshabilitados en producción
};
